export interface VolumeDriverConfigurationsState {
  isCreating: boolean;
  isModalOpened: boolean;
}

export const initialState: VolumeDriverConfigurationsState = {
  isCreating: true,
  isModalOpened: false,
};
